import { NgModule } from '@angular/core';
import { CommonModule } from "@angular/common";
import { RouterModule } from '@angular/router';
/* Aternative Imports */
import { NgbActiveModal, NgbModule } from "@ng-bootstrap/ng-bootstrap";
import { FullCalendarModule } from "@fullcalendar/angular"; // the main connector. must go first
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { SlickCarouselModule } from "ngx-slick-carousel";
import { NgSelectModule } from '@ng-select/ng-select';
import { NgxPermissionsModule } from "ngx-permissions";
import { Utils } from "../../util/util";
import { SuiteModulesComponent } from "./suite-modules/suite-modules.component";
import { SidebarComponent } from "./sidebar/sidebar.component";
import { MenuComponent } from "./menu/menu.component";
import { HeaderComponent } from "./header/header.component";
import { HeaderReqDocumentComponent } from "./header-req-document/header-req-document.component";
import { SidebarReqComponent } from "./sidebar-req/sidebar-req.component";
import { HeaderProfileComponent } from "./header-profile/header-profile.component";
import { AttachmentComponent } from "./pop-up/attachment/attachment.component";
import { SignatureAttachmentComponent } from './pop-up/signature-attachment/signature-attachment.component';
import { LexgosignSendComponent } from './pop-up/lexgosign-send/lexgosign-send.component';
import { LexgosignPlacementComponent } from './pop-up/lexgosign-placement/lexgosign-placement.component';
import { LexgosignFolderPickerComponent } from './pop-up/lexgosign-folder-picker/lexgosign-folder-picker.component';
import { LexgosignSignComponent } from './pop-up/lexgosign-sign/lexgosign-sign.component';
import { LexgosignProgressComponent } from './pop-up/lexgosign-progress/lexgosign-progress.component';
import { LexgosignDetailComponent } from './lexgosign-detail/lexgosign-detail.component';
import { DocumentTemplateComponent } from './pop-up/document-template/document-template.component';
import { DropAndDragDirective } from "./directive/drop-and-drag.directive";
import { AttachmentViewComponent } from "./components/attachment-view/attachment-view.component";
import { CreateNoteComponent } from "./pop-up/create-note/create-note.component";
import { PortalClientMessagesModalComponent } from "./pop-up/portal-client-messages-modal/portal-client-messages-modal.component";
import { AddCollaboratorComponent } from "./components/add-collaborator/add-collaborator.component";
import { CalendarViewComponent } from "./components/calendar-view/calendar-view.component";
import { DeleteAttachmentComponent } from "./pop-up/delete-attachment/delete-attachment.component";
import { EditAttachmentCategoryComponent } from "./pop-up/edit-attachment-category/edit-attachment-category.component";
import { DownloadAttachmentsComponent } from "./pop-up/download-attachments/download-attachments.component";
import { DeleteAlertComponent } from "./pop-up/delete-alert/delete-alert.component";
import { ConfirmActionModalComponent } from "./components/confirm-action-modal/confirm-action-modal.component";
import { DeleteActivityComponent } from "./pop-up/delete-activity/delete-activity.component";
import { CustomfieldsInputComponent } from "./customfields-input/customfields-input.component";
import { CustomfieldsComponent } from "./customfields/customfields.component";
import { AppTreeSelectComponent } from "./app-tree-select/app-tree-select.component";
import { FilterPipe } from "./pipe/filter.pipe";
import { TruncatePipe } from "../../pipes/truncate.pipe";
import { SearchFilterPipe } from '@app/pipes/search.pipe';
import { ByPassSecurityPipe } from '@app/pipes/sanitize.pipe';
import { HistoricalRequirementComponent } from "../requirement/historical-requirement/historical-requirement.component";
import { DialogWarningDeleteComponent } from "../../dialogs/dialog-warning-delete/dialog-warning-delete.component";
import { DocumentPreviewComponent } from "../documents/document-preview/document-preview.component";
import { ClausesComponent } from "../documents/clauses/clauses.component";
import { ButtonComponent } from "../../shared/button/button.component";
import { NotesComponent } from './notes/notes.component';
import { AvatarPhotoComponent } from '@layout/avatar-photo/avatar-photo.component';
import { ActivityAlertComponent } from './pop-up/activity-alert/activity-alert.component';
import { AdminTabsComponent } from "@app/admin/admin-tabs/admin-tabs.component";
import { CaraAdminDirective } from "@app/admin/cara-admin.directive";
import { AdminReportModalComponent } from '@app/admin/admin-report-modal/admin-report-modal.component';
import { WithoutRegistrationComponent } from './without-registration/without-registration.component';
import { DeleteNoteComponent } from './pop-up/delete-note/delete-note.component';
import { FormatCustomfieldDirective } from './directive/format-customfield.directive';
import { ReplacePipe } from './pipe/replace.pipe';
import { ValueArrayPipe } from './pipe/value-array.pipe';
import { PjudComponent } from "@app/pjud/pjud.component";
import { MinimalCardsComponent } from './minimal-cards/minimal-cards.component';
import { CustomFieldsSwitchComponent } from './custom-fields-switch/custom-fields-switch.component';
import { SignatureDetail } from "@flows/shared/signature-detail/signature-detail";
import { AttachmentToSignComponent } from "@flows/shared/components/attachment-to-sign/attachment-to-sign.component";
import { TemplateDetailComponent } from './template-detail/template-detail.component';
import { CollaboratorRequirementComponent } from '../requirement/collaborator-requirement/collaborator-requirement.component';
import { DialogWarningComponent } from '@app/dialogs/dialog-warning/dialog-warning.component';
import { CostRequirementComponent } from '../requirement/cost-requirement/cost-requirement.component';
import { ModalFormCostComponent } from './pop-up/modal-form-cost/modal-form-cost.component';
import { CalendarProgrammingComponent } from '@app/shared/calendar-programming/calendar-programming.component';
import { PromptsAiComponent } from './pop-up/prompts-ai/prompts-ai.component';
import { MarkdownModule } from 'ngx-markdown';

import { NgbPopoverModule } from '@ng-bootstrap/ng-bootstrap';
import { ModalFormFeeComponent } from './pop-up/modal-form-fee/modal-form-fee.component';
import { CurrencyPipe } from '@app/pipes/currency.pipe';
import { CurrencyDirective } from './directive/currency.directive';
import { AlertActionModalComponent } from './pop-up/alert-action-modal/alert-action-modal.component';
import { PjudUnavailableModalComponent } from './pop-up/pjud-unavailable-modal/pjud-unavailable-modal.component';
import { EmailHistoryComponent } from './email-history/email-history.component';

import { NgxMaskDirective, NgxMaskPipe, provideNgxMask } from 'ngx-mask';
import { DirectivesModule } from '@app/directives/directives.module';
import { TimeFormatPipe } from '@flows/shared/pipe/timeFormat.pipe';
import { FormatInstantPipe } from '@flows/shared/pipe/format-instant.pipe';
import { ActivityInstantPipe } from '@flows/shared/pipe/activity-instant.pipe';
import { AlertInstantPipe } from '@flows/shared/pipe/alert-instant.pipe';
import { ToastsContainer } from './toast/toasts-container.component';
import { QuillModule } from 'ngx-quill';
import { EditNoteComponent } from "./pop-up/edit-note/edit-note.component";
import { DeleteTemplateComponent } from './pop-up/delete-template/delete-template.component';
import { BatchUpdateRequirementComponent } from './batchupdaterequirement/batchupdaterequirement.component';
import { BatchAssigmentUserComponent } from './pop-up/batch-assigment-user/batch.assigment.user.component';
import { BatchDeleteRequirementComponent } from './pop-up/batch-delete-requirement/batch-delete-requirement.component';
import { BatchScrapingToggleConfirmComponent } from './pop-up/batch-scraping-toggle-confirm/batch-scraping-toggle-confirm.component';
@NgModule({
    declarations: [
        MenuComponent,
        SuiteModulesComponent,
        HeaderComponent,
        HeaderReqDocumentComponent,
        HeaderProfileComponent,
        HistoricalRequirementComponent,
        SidebarReqComponent,
        SidebarComponent,
        AttachmentComponent,
        SignatureAttachmentComponent,
        LexgosignSendComponent,
        LexgosignPlacementComponent,
        LexgosignFolderPickerComponent,
        LexgosignSignComponent,
        LexgosignProgressComponent,
        DocumentTemplateComponent,
        AttachmentViewComponent,
        CreateNoteComponent,
        AddCollaboratorComponent,
        CalendarViewComponent,
        DeleteAttachmentComponent,
        EditAttachmentCategoryComponent,
        DownloadAttachmentsComponent,
        DeleteAlertComponent,
        ConfirmActionModalComponent,
        DeleteActivityComponent,
        CustomfieldsInputComponent,
        CustomfieldsComponent,
        AppTreeSelectComponent,
        FilterPipe,
        TruncatePipe,
        SearchFilterPipe,
        ByPassSecurityPipe,
        DialogWarningDeleteComponent,
        DocumentPreviewComponent,
        ClausesComponent,
        ButtonComponent,
        NotesComponent,
        AvatarPhotoComponent,
        ActivityAlertComponent,
        AdminTabsComponent,
        CaraAdminDirective,
        AdminReportModalComponent,
        WithoutRegistrationComponent,
        DeleteNoteComponent,
        PjudComponent,
        MinimalCardsComponent,
        CustomFieldsSwitchComponent,
        AttachmentToSignComponent,
        TemplateDetailComponent,
        CollaboratorRequirementComponent,
        DialogWarningComponent,
        CostRequirementComponent,
        ModalFormCostComponent,
        CalendarProgrammingComponent,
        DropAndDragDirective,
        FormatCustomfieldDirective,
        FilterPipe,
        TruncatePipe,
        ReplacePipe,
        ValueArrayPipe,
        SignatureDetail,
        LexgosignDetailComponent,
        PromptsAiComponent,
        ModalFormFeeComponent,
        CurrencyPipe,
        CurrencyDirective,
        AlertActionModalComponent,
        PjudUnavailableModalComponent,
        EmailHistoryComponent,
        TimeFormatPipe,
        FormatInstantPipe,
        ActivityInstantPipe,
        AlertInstantPipe,
        ToastsContainer,
        EditNoteComponent,
        DeleteTemplateComponent,
        BatchUpdateRequirementComponent,
        BatchAssigmentUserComponent,
        BatchDeleteRequirementComponent,
        BatchScrapingToggleConfirmComponent
    ],
    imports: [
        CommonModule,
        FullCalendarModule,
        FormsModule,
        ReactiveFormsModule,
        NgbModule,
        SlickCarouselModule,
        NgxPermissionsModule.forChild(),
        NgSelectModule,
        RouterModule,
        NgbPopoverModule,
        MarkdownModule,
        NgxMaskDirective,
        NgxMaskPipe,
        DirectivesModule,
        QuillModule,
        PortalClientMessagesModalComponent
    ],
    exports: [
        MenuComponent,
        SuiteModulesComponent,
        HeaderComponent,
        HeaderReqDocumentComponent,
        HeaderProfileComponent,
        HistoricalRequirementComponent,
        SidebarReqComponent,
        SidebarComponent,
        AttachmentComponent,
        SignatureAttachmentComponent,
        LexgosignSendComponent,
        LexgosignPlacementComponent,
        LexgosignFolderPickerComponent,
        LexgosignSignComponent,
        LexgosignProgressComponent,
        LexgosignDetailComponent,
        DocumentTemplateComponent,
        AttachmentViewComponent,
        CreateNoteComponent,
        AddCollaboratorComponent,
        CalendarViewComponent,
        DeleteAttachmentComponent,
        EditAttachmentCategoryComponent,
        DeleteAlertComponent,
        ConfirmActionModalComponent,
        DeleteActivityComponent,
        CustomfieldsInputComponent,
        CustomfieldsComponent,
        AppTreeSelectComponent,
        FilterPipe,
        TruncatePipe,
        SearchFilterPipe,
        ByPassSecurityPipe,
        DialogWarningDeleteComponent,
        DocumentPreviewComponent,
        ClausesComponent,
        ButtonComponent,
        NotesComponent,
        AvatarPhotoComponent,
        ActivityAlertComponent,
        AdminTabsComponent,
        CaraAdminDirective,
        AdminReportModalComponent,
        WithoutRegistrationComponent,
        DeleteNoteComponent,
        MinimalCardsComponent,
        CustomFieldsSwitchComponent,
        CalendarProgrammingComponent,
        DropAndDragDirective,
        FormatCustomfieldDirective,
        ReplacePipe,
        ValueArrayPipe,
        FilterPipe,
        TruncatePipe,
        NgSelectModule,
        NgbModule,
        NgbPopoverModule,
        ModalFormFeeComponent,
        CurrencyPipe,
        CurrencyDirective,
        AlertActionModalComponent,
        PjudUnavailableModalComponent,
        EmailHistoryComponent,
        NgxMaskDirective,
        NgxMaskPipe,
        TimeFormatPipe,
        FormatInstantPipe,
        ActivityInstantPipe,
        AlertInstantPipe,
        ToastsContainer,
        EditNoteComponent,
        DeleteTemplateComponent,
        BatchUpdateRequirementComponent,
        BatchAssigmentUserComponent,
        BatchDeleteRequirementComponent,
        BatchScrapingToggleConfirmComponent
    ],
    providers: [
        Utils,
        provideNgxMask()
    ]
})
export class SharedModule { }
